import { LocaleDate } from '@mi-front/ui';
import moment from 'moment-timezone';
import React from 'react';
import { useTimezone } from '@app/core/hooks/useTimezone';

interface Props extends React.ComponentProps<typeof LocaleDate> {
  tz?: string;
}

export const LDate = (p: Props) => {
  const { value, tz: passedTz, ...rest } = p;
  const contextTz = useTimezone();
  const tz = passedTz || contextTz;

  return (
    <span title={moment(value).tz(tz).format('LLLL (Z)')}>
      <LocaleDate timeZone={tz || undefined} value={value} {...rest} />
    </span>
  );
};
